import script from "./messageListDrawer.vue?vue&type=script&lang=ts&setup=true"
export * from "./messageListDrawer.vue?vue&type=script&lang=ts&setup=true"

import "./messageListDrawer.vue?vue&type=style&index=0&id=5eae4f95&scoped=true&lang=scss"

import exportComponent from "E:\\vue\\saudiInspectionSystem\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5eae4f95"]])

export default __exports__